import React from 'react'
import Header from './components/header'
import Letter from './components/Letter'
import Bonuses from './components/Bonuses'
import ClinicalStudies from '../u1/components/Studies'


const index = () => {
  return (
    <div  className='bg-slate-50'>
      <div>
        <Header/>
        <Letter/>
      </div>
      <Bonuses/>
      <ClinicalStudies/>
    </div>
  )
}

export default index
